import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'PeriodosLog';

export interface PeriodosLogRequest{
	año: number;
	periodo: number;
}

export class PeriodosLogAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

    ListarPeriodosLog(PeriodosLogReq: PeriodosLogRequest){
        return this.cliente.post(PeriodosLogReq, `/ListarPeriodosLog`);
    }
}